import React from "react";
import { useNavigate } from "react-router-dom";
import CommonNavbar from "../../Common/CommonLayout/CommonNavbar";
import { ToastContainer } from "react-toastify";
import { Card, Form, Row, Col, Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const PaymentConfirmed = () => {
  const navigate = useNavigate();

  const { state } = useLocation();
  const { counsellorName, appointmentDate, appointmentTime, zoomMeetingLink } = state;

  const handleHome = () => {
    navigate("/client/ClientDashboard")
  }


  return (
    <>
      <div style={{ paddingBottom: "30px" }}>
        <ToastContainer />
        <CommonNavbar />
        <Container className="d-flex justify-content-center mt-4">
          <Card
            className="shadow p-4"
            style={{ maxWidth: "500px", width: "100%" }}
          >
            <Card.Body>
              {/* <h6 className="text-center">Payment Successful! </h6> */}
              <h4 className="text-center">Appointment Booked Successfully!</h4>
              <h6 className="text-center">Booking Details</h6>
              <hr />
              <Form style={{ paddingLeft: "40px" }}>
                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Counselor Name:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>{counsellorName}</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Date:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>{appointmentDate}</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Time:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>{appointmentTime}</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Medium:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>Zoom Meeting</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Meeting Duration:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>60 min</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Amount:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>0 $</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Meeting Link:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label style={{ color: "blue" }}>
                        {zoomMeetingLink}
                      </Form.Label>
                    </Col>
                  </Row>
                </Form.Group><br />
                <center>
                  <button type="submit" className="btn btn-primary">
                    Download Receipt
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleHome}
                  >
                    Home
                  </button>
                </center>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};
export default PaymentConfirmed;
